export default __webpack_public_path__ + "static/media/bg.fefb633e.png";